import { Component } from '@angular/core';

@Component({
  selector: 'lgb-logo',
  templateUrl: './logo.html',
  styleUrl: './logo.css',
  standalone: false
})
export class Logo {

}
